export const sitecoreCloudDocumentationQuickaction = {
  type: 'ui',
  name: 'Sitecore Cloud Portal documentation',
  icon: {
    type: 'mdi',
    src: 'mdiBookOpenPageVariantOutline',
  },
  color: 'gray',
  link: {
    type: 'external-link',
    to: 'https://doc.sitecore.com/portal/en/developers/sitecore-cloud-portal/index-en.html?contextId=portal-docs-home',
  },
};
